<!--
 * @Description: 原料复检
 * @Author: wangwangwang
 * @Date: 2020-09-21 14:09:06
 * @LastEditors: wangwangwang
 * @LastEditTime: 2020-12-16 10:15:22
-->
<template>
  <SpecialCheckout type="1" typeId="2" />
</template>

<script>
import SpecialCheckout from './component/specialCheckout'
export default {
  components: {
    SpecialCheckout
  },
};
</script>
